import { render, staticRenderFns } from "./downloadTask.vue?vue&type=template&id=56efc844&scoped=true"
import script from "./downloadTask.vue?vue&type=script&lang=js"
export * from "./downloadTask.vue?vue&type=script&lang=js"
import style0 from "./downloadTask.vue?vue&type=style&index=0&id=56efc844&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56efc844",
  null
  
)

export default component.exports